import { Controller } from "@hotwired/stimulus";
import IMask from "imask";

export default class extends Controller {
  connect() {
    // Máscara de data: DD/MM/AAAA.
    this.mask = IMask(this.element, {
      mask: Date,
      pattern: "d{/}m{/}Y",
      blocks: {
        d: { mask: IMask.MaskedRange, from: 1, to: 31 },
        m: { mask: IMask.MaskedRange, from: 1, to: 12 },
        Y: { mask: IMask.MaskedRange, from: 1900, to: 2100 },
      },
      format: function (date) {
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        return [
          day.toString().padStart(2, "0"),
          month.toString().padStart(2, "0"),
          year,
        ].join("/");
      },
      parse: function (str) {
        const [day, month, year] = str.split("/");
        return new Date(year, month - 1, day);
      },
      autofix: true,
    });
  }

  disconnect() {
    if (this.mask) this.mask.destroy();
  }
}
